import { Record } from 'immutable';

import type { JSX } from 'react';

type NotificationDialogProps = {
  title: string;
  content: string | JSX.Element;
  buttonLabel: string | null;
  onClose: null;
  size: string | null;
  dialogProps: null | {
    disableBackdropClick: boolean;
    disableEscapeKeyDown: boolean;
  };
};

export const mkNotificationDialogProps: Record.Factory<NotificationDialogProps> = Record<NotificationDialogProps>({
  title: 'Notification',
  content: '',
  buttonLabel: 'Okay',
  onClose: null,
  size: null,

  dialogProps: null,
});

export const DIALOG_TYPE = 'DIALOG_NOTIFICATION';
